import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyThroat = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.95822 21.375V16.1542C4.80675 15.0874 4.00371 13.6983 3.65396 12.1681C3.30422 10.6379 3.42402 9.03778 3.99773 7.57673C4.57144 6.11568 5.57239 4.86158 6.86988 3.9782C8.16736 3.09483 9.70107 2.62323 11.2707 2.625C17.2199 2.625 18.5041 7.52333 20.6249 13.025C20.6612 13.1197 20.674 13.2218 20.6621 13.3226C20.6502 13.4233 20.614 13.5197 20.5566 13.6033C20.4992 13.6869 20.4223 13.7554 20.3326 13.8027C20.2429 13.85 20.143 13.8748 20.0416 13.875H18.4582V16.375C18.4582 17.038 18.1948 17.6739 17.726 18.1428C17.2571 18.6116 16.6213 18.875 15.9582 18.875H14.7082V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4583 16.375H12.2083C11.5452 16.375 10.9093 16.6384 10.4405 17.1072C9.97164 17.5761 9.70825 18.212 9.70825 18.875V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyThroat.displayName = 'SvgBodyThroat';
export default SvgBodyThroat;
